enum GoogleReportRequest {
  Total = 'GOOGLE_TOTAL',
  Date = 'GOOGLE_DATE',
  Channel = 'GOOGLE_CHANNEL',
  Device = 'GOOGLE_DEVICE',
  Campaign = 'GOOGLE_CAMPAIGN',
  Advertiser = 'GOOGLE_ADVERTISER',
  Placement = 'GOOGLE_PLACEMENT',
  Creative = 'GOOGLE_CREATIVE',
  Publisher = 'GOOGLE_PUBLISHER',
  DayOfWeek = 'GOOGLE_DAYS_OF_WEEK',
  Daypart = 'GOOGLE_DAYPART',
  Dma = 'GOOGLE_DMA',
  AppUrl = 'GOOGLE_APP_URL',
  State = 'GOOGLE_STATE',
  DmaBoundaries = 'GOOGLE_DMA_BOUNDARIES',
  StateBoundaries = 'GOOGLE_STATE_BOUNDARIES',
}

export default GoogleReportRequest;
